<template>
  <div class="s-form">
    <div class="s-form-head">
      <h3 class="f-md bold">Request Information</h3>
    </div>
    <form class="s-form-container"
          @submit.prevent="submit"
          :style="{
        opacity: state === 'Sending...' ? 0.6 : 1,
        'pointer-events': state === '' ? 'auto' : 'none',
      }">

      <div class="s-form-rows">
        <div class="s-form-row">
          <div class="s-form-col">
            <label class="s-form-label">Name</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="text"
                   autocomplete="no"
                   name="firstname"
                   v-model="request.firstname"
                   required />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="s-form-label">Entity Name</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="text"
                   autocomplete="no"
                   name="lastname"
                   v-model="request.lastname"
                   required />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="s-form-label">Email</label>
          </div>
          <div class="s-form-col">
            <input class="f-md s-form-field"
                   type="email"
                   autocomplete="off"
                   name="email"
                   v-model="request.email"
                   required />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="s-form-label">Entity Type</label>
          </div>
          <div class="s-form-col">
            <div class="s-form-dropdown">
              <span class="s-form-field">-</span>
              <ul>
                <li>Consultant</li>
                <li>Endownment</li>
                <li>Family Office</li>
                <li>Foundation</li>
                <li>Fund of Funds</li>
                <li>High Net Worth Individual</li>
                <li>Outsourced CIO</li>
                <li>Pension</li>
                <li>Private Bank</li>
                <li>Other Institutional Investor</li>
              </ul>
            </div>
            <input class="s-form-hidden"
                   type="text"
                   autocomplete="off"
                   name="entity"
                   ref="entity" />
          </div>
        </div>

        <div class="s-form-row">
          <div class="s-form-col">
            <label class="s-form-label">Tax Domicile</label>
          </div>
          <div class="s-form-col">
            <div class="s-form-dropdown">
              <span class="s-form-field">-</span>
              <ul>
                <li>US Based</li>
                <li>Non-US Based</li>
                <li>Both</li>
              </ul>
            </div>
            <input class="s-form-hidden"
                   type="text"
                   autocomplete="off"
                   name="tax"
                   ref="tax" />
          </div>
        </div>

        <div class="s-form-row s-form-row--textarea">
          <div class="s-form-col">
            <label class="s-form-label">Request</label>
          </div>
          <div class="s-form-col">
            <textarea class="f-md s-form-field"
                      type="text"
                      autocomplete="off"
                      name="description"
                      rows="3"
                      maxlength="500"
                      required
                      v-model="request.request" />
          </div>
        </div>
      </div>

      <div class="s-form-row recaptcha">
        <div class="s-recaptcha">
          <vue-recaptcha @verify="verify"
                         :loadRecaptchaScript="true"
                         :sitekey="'6LdvYqMZAAAAAAFYEJGWgZNJcheSW4niTUPD784F'" />
        </div>
      </div>

      <div class="s-form-bottom">
        <div class="s-form-col">
          <label class="s-form-label s-form-label--checkbox">
            Accept Terms & Disclaimers
            <input class="s-form-checkbox" type="checkbox" required />
            <span class="s-form-checkmark p-cta"></span>
          </label>
        </div>
        <div class="s-form-col">
          <button class="f-xs s-form-send p-cta">{{ state === '' ? 'Send Information' : state }}</button>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
  import axios from 'axios';

  import VueRecaptcha from 'vue-recaptcha';
  import Form from './form';

  let form;

  export default {
    components: {
      VueRecaptcha,
    },
    mounted() {
      form = new Form();
      form.init();
    },
    destroyed() {
      form.destroy();
    },
    data() {
      return {
        path: document.location.href.indexOf('localhost') >= 0 ? 'http://dev.vrcapital.adorator.io/' : '/',
        state: '',
        request: {
          verified: false,
          firstname: '',
          lastname: '',
          email: '',
          entity: '',
          tax: '',
          request: '',
        },
      };
    },
    methods: {
      verify() {
        this.request.verified = true;
      },
      submit(evt) {
        if (!this.request.verified) return;
        evt.preventDefault();
        this.state = 'Sending...';
        const data = new FormData();
        data.append('firstname', this.request.firstname);
        data.append('lastname', this.request.lastname);
        data.append('email', this.request.email);
        data.append('entity', this.$refs.entity.value);
        data.append('tax', this.$refs.tax.value);
        data.append('request', this.request.request);
        data.append('type', 'request');
        axios.post(`${this.path}post.php`, data).then((response) => {
          console.log('Response:', JSON.stringify(response.data));
          if (response.data.error) {
            console.error('Server error:', response.data.message, response.data.debug);
            this.state = 'Error. Try again.';
            this.$el.querySelector('.s-form-send').style.color = '#fff';
            setTimeout(() => { this.state = ''; }, 4000);
            return;
          }
          console.log('success', response.data.message);
          this.state = 'Sent!';
          this.$el.querySelector('.s-form-send').style.color = '#fff';
          setTimeout(() => {
            this.state = '';
            // Reset Form
            this.request = {
              verified: false,
              firstname: '',
              lastname: '',
              email: '',
              entity: '',
              tax: '',
              request: '',
            };
            Array.from(this.$el.querySelectorAll('.s-form-dropdown .s-form-field')).forEach((e) => { e.innerHTML = '-'; });
          }, 4000);
        }).catch((error) => {
          console.error('Request failed:', error);
          console.error('Response data:', error.response ? JSON.stringify(error.response.data) : 'No response');
          console.error('Status:', error.response ? error.response.status : 'No status');
          this.state = 'Error. Try again.';
          this.$el.querySelector('.s-form-send').style.color = '#fff';
          setTimeout(() => { this.state = ''; }, 4000);
        });
      },
    },
  };
</script>
